<template>
  <m-step-layout title="Member Accounts" class="mt-16" type="sm">
    <template #description>
      <p class="text-base text-gray-700">Please add the member account(s) for each person.</p>
      <!-- eslint-disable-next-line max-len -->
      <p class="text-sm text-gray-600 pt-2">
        We need some way of identifying each account. Most people use the
        identifier shown on the fund's member statements.
      </p>
    </template>

    <div class="bg-white p-6 rounded">
      <div class="">
        <p class="font-bold">Add member accounts?</p>
        <p>Expand each member to add their accounts.</p>
        <p class="text-xs text-gray-600">
          It is only necessary to include accounts from which payments will be
          made.
        </p>
        <p class="text-xs text-gray-800 font-semibold">
          Note: Editing an account will reset any rules that have been created.
        </p>
      </div>

      <div class="mt-8 w-full border-2 rounded-lg">
        <header class="rounded-t-lg w-full bg-gray-100 grid grid-cols-12 px-8">
          <!-- eslint-disable-next-line max-len -->
          <p
            class="ml-12 col-span-6 px-4 py-2 uppercase font-medium text-sm text-gray-600"
          >
            Account Type
          </p>
          <p class="col-span-3 px-4 py-2 uppercase font-medium text-sm text-gray-600">
            Identifier
          </p>
          <p class="col-span-2 px-4 py-2 uppercase font-medium text-sm text-gray-600">
            Tax Free %
          </p>
          <p class="px-4 py-2 uppercase font-medium text-sm text-gray-600 text-center">#</p>
        </header>
        <div class="p-4 space-y-4">
          <member-account
            v-for="member in members"
            :key="member.uuid"
            :uuid="member.uuid"
            :name="member.name"
            :accounts="member.accounts"
          />
          <p v-if="$v.accounts.$invalid" class="text-red-500">
            At least one account is required.
          </p>
        </div>
      </div>
    </div>
    <div class="mt-6 text-right">
      <m-button class="ml-2" @click="handleBackStep" ref="back-btn"
        >Back</m-button
      >
      <m-button
        class="ml-2"
        @click="handleNextStep"
        ref="next-btn"
        :disabled="$v.$invalid"
        :class="{ 'cursor-not-allowed': $v.$invalid }"
        >Continue</m-button
      >
    </div>
  </m-step-layout>
</template>

<script>
import _ from 'lodash';
import { required, minLength } from 'vuelidate/lib/validators';
import ToolKitMixin from '@/app/mixins/toolkit/item';
import MemberAccount from './member-account.vue';

export default {
  name: 'member-accounts',
  components: {
    MemberAccount,
  },
  mixins: [ToolKitMixin],
  computed: {
    members() {
      const { members } = this.getItem;
      const formattedMembers = _.values(members);

      return formattedMembers;
    },
    accounts() {
      return this.members.flatMap(member => _.values(member.accounts));
    },
  },
  methods: {
    handleBackStep() {
      this.$emit('backStep');
    },
    handleNextStep() {
      this.$emit('nextStep');
    },
  },
  validations: {
    accounts: {
      required,
      minLength: minLength(1),
    },
  },
};
</script>
